<template>
    <div>
        <buttonlist
                @help="help"
                @search="search"
                @reflash="reflash"
                @exps="exps"
                @del="del"
                ref="SetBtn"
        ></buttonlist>
        <el-table
                id="xpane-0"
                :data="dataSet"
                v-loading="loading"
                :highlight-current-row="true"
                show-overflow-tooltip="true"
                border
                stripe
                size="mini"
                :height="tableHeight"
                header-row-class-name="headerclass"
                @selection-change="handleSelectionChange"
                style="width: 100%; margin-top:0px"
                ref="singleTable"
        >
            <el-table-column type="selection"></el-table-column>
            <el-table-column show-overflow-tooltip prop="vender_code" :label="$t('getapi[1196]')" fixed="left">
                <!--<template slot-scope="scope">
                    <el-input  type="text" v-model="scope.row.vender_code"
                               readonly
                               size="mini"
                    >
                        <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectVender(scope)"></i>
                    </el-input>
                </template>-->
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="vender_balance" :label="$t('getapi[7594]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="vender_status" :label="$t('getapi[1237]')"></el-table-column>
            <el-table-column prop="vender_name" :label="$t('getapi[2023]')">
                <template slot-scope="scope">
                    <el-input  type="text" v-model="scope.row.vender_name"
                               readonly
                               size="mini"
                    >
                        <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectVender(scope)"></i>
                    </el-input>
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="remark" :label="$t('getapi[143]')"></el-table-column>
            <el-table-column prop="status" :label="$t('getapi[552]')">
                <template scope="scope">
                    <span>{{ scope.row.status | lanchange}}</span>
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="updateuser" :label="$t('getapi[6254]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="updatetime" :label="$t('getapi[6255]')"></el-table-column>
        </el-table>
        <el-row class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
            </el-col>
        </el-row>
        <serce :isVisible="isVisible" queryData="FinPaymentDueExcel_Sort" ref="ser" @getser="serclick"></serce>
        <selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/FrmFPDSort/ShowVender'" @callback="getVender" ref="vender"></selector>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    export default {
        name:'3_fpdvender',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('3_fpdvender'), // 当前页数据量
                SelectIndexs: 1, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                index: '',
                selectData: [],
                scrollTop:0,
            };
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
        },
        mounted: function() {
            let that = this;
            that.userData = sessionStorage.getItem('userData');
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6612]"),this.$t("getapi[5131]"));
            },
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                if(that.selectData.length > 0){
                    that.$refs.SetBtn.SetOneBtnEnable('del', true)
                }
                that.btnauthority()
            },
            btnauthority(){
                let that = this
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('3_fpdvender',val)
                this.getView();
                this.authority();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
                this.authority();
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'FinPaymentDueExcel_Sort');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndexs,
                    Ids: '',
                    Param: datac
                };
                that.$http.urlpost('/FrmFPDSort/DataList', data, function(res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                        that.authority();
                    } else {
                        that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                    }
                });
            },
            // 刷新
            reflash() {
                let that = this;
                that.getView();
            },
            // 导出
            exps() {
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: '',
                    LangType:that.$processdata.getLang(),
                    Param: datac,
                    fromname: that.$t('getapi[6612]')
                };
                that.$refs.SetBtn.SetOneBtnEnable('exps',false);
                that.$http.urlpost('/FrmFPDSort/DataList/ExportToExecl', parm, function(res) {
                    that.$refs.SetBtn.SetOneBtnEnable('exps',true);
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
            },
            selectVender(row){
                let that = this;
                that.index = row.$index
                let param = {
                    vender_code: row.row.vender_code,
                    vender_name: row.row.vender_name
                }
                that.$refs.vender.clearInput(true, param);
            },
            getVender(data){
                let that = this
                that.dataSet[that.index].vender_code = data.vender_code
                that.dataSet[that.index].vender_name = data.vender_name
                let parm = {
                    vender_name: data.vender_name,
                    NewVenderCode: data.vender_code
                }
                that.updateToCode(parm)
            },
            // 根据供应商名称修订代码
            updateToCode(parm){
                let that = this
                that.$http.urlpost('/FrmFPDSort/UpdateToCode', parm, function(res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.getView()
                    }
                });
            },
            // 多选
            handleSelectionChange(val) {
                let that = this;
                that.selectData = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectData.push(val[i]);
                }
                that.authority()
            },
            //删除
            del(){
                let that = this;
                this.$confirm(that.$t('getapi[8881]'), that.$t('getapi[194]'), {//'请确认，是否禁用选择的记录（禁用后不再自动计算供应商账期）?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        this.$confirm(that.$t('getapi[8882]'), that.$t('getapi[194]'), {//禁用记录后是否需要删除供应商的账期信息（是-删除信息，否-不删除）
                            confirmButtonText: that.$t('getapi[2052]'),
                            cancelButtonText: that.$t('getapi[2053]'),
                            type: 'warning'
                        })
                            .then(() => {
                                that.delData(1,'禁用')
                            })
                            .catch(() => {
                                that.delData(0,'禁用')
                            });
                    })
                    .catch(() => {
                    });
            },
            delData(deletedue, newstatus){
                let that = this
                let arr = []
                for(let i = 0;i< that.selectData.length; i++){
                    arr = [...arr,{
                        vender_code: that.selectData[i].vender_code,
                        vender_name: that.selectData[i].vender_name,
                    }]
                }
                let parm = {
                    Rows: arr,
                    DeleteDue: deletedue,
                    new_status: newstatus
                }
                that.$http.urlpost('/FrmFPDSort/UpdateToStatus', parm, function(res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.getView()
                    }
                });
            }
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
</style>
